import styled from 'styled-components';
import { colors } from './colors';

export const Paragraph = styled.span`
  color: ${colors.darkTitle};
  font-family: 'Montserrat', sans-serif;
  font-size: 1.4rem;
`;
